import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import ImageContainer from "@shared/components/contents/imageContainer/ImageContainer";
import Icon from "@shared/components/Icon";
const ColorImageBlock = (props) => {
    const { image, backgroundColor, icon, maxVerticalSize, verticalSize, horizontalSize, } = props;
    return (_jsxs(Stack, { sx: {
            display: { xs: "none", sm: "none", md: "flex" },
            width: `${horizontalSize}px`,
            maxWidth: "100%",
            flexShrink: 0,
            height: `${maxVerticalSize}px !important`,
        }, children: [image && _jsx(ImageContainer, { ratio: 64, children: image }), _jsx(Stack, { sx: {
                    maxWidth: `${horizontalSize}px !important`,
                    height: `${verticalSize}px !important`,
                    backgroundColor,
                    justifyContent: "center",
                    alignItems: "center",
                }, children: _jsx(Icon, { ...icon, style: { fontSize: 64, minHeight: "64px", minWidth: "64px" } }) })] }));
};
export default ColorImageBlock;
